//import axios from "axios";
//import { response } from "express";
import { http } from '@/services/http_service';
import * as auth from '@/services/auth_service';
import jwt from "jsonwebtoken";
let timer;
let logintime= 360 * 60 *1000;//15 * 60 *1000;//1000 은 1초 6분 셋팅
export default {
  refreshExpire(context){
    clearTimeout(timer);
    timer = setTimeout(function() {
      context.dispatch("autoLogout");
    }, logintime);
  },
  login(context, payload) {
    return http()
      .post("/auth/login", payload)
      .then((response) => {
        if (response.status === 200) {
          //setToken(response.data)
          context.dispatch("setToken", response.data);
          console.log('로그인 하면서 만드는데이터'+ JSON.stringify(response.data))
        }
        return response.data;
      });
  },
  setToken(context, payload) {
    const token = jwt.sign({ user: payload }, "lvsolutiontoken"); //npm i jsonwebtoken
    const expiresIn = +logintime ;
    const expirationDate = new Date().getTime() + expiresIn;

    localStorage.setItem(
      "lv_token",
      //user.access_token
      //JSON.stringify(user)
      token
    );
    localStorage.setItem("userId", payload.user.id);
    localStorage.setItem("tokenExpiration", expirationDate);
    console.log("여기는 setToken" + payload.access_token);

    timer = setTimeout(function() {
      context.dispatch("autoLogout");
    }, expiresIn);

    context.commit("setUser", {
      token: payload.access_token,
      currentUser: payload.user,
    });
    console.log("getItem" + localStorage.getItem("userId"));
  },
  tryLogin(context) {
    localStorage.removeItem("vuex");
    const token = localStorage.getItem("lv_token");
    const userId = localStorage.getItem("userId");
    //const tokenExpiration = localStorage.getItem("tokenExpiration");
    const vuex = JSON.parse( localStorage.getItem("vuex"));
    //console.log("vuex", vuex.auth.currentUser);
    if(!token && !userId && !vuex){
        console.log('손님으로 닉네임 생성');
        //임시 손님 아이디를 만들어 낸다.
        context.commit("setGuestUser", {
          token: null,
            currentUser: {nic:'손님_'+ auth.makeId(8),id:0}
        });
       
    }
    if(vuex)
    {
      if(!vuex.auth.currentUser)
      {
        //임시 손님 아이디를 만들어 낸다.
        context.commit("setGuestUser", {
          token: null,
          currentUser: {nic:'손님_'+ auth.makeId(8),id:0}
        });
        
      }
    }
    http().get("/auth/userIP").then((response)=>{
        context.commit("setUserIP", {
            userIP: response.data
        });
        //console.log('response'+response.data.nic)
    });
    http().post("/connect/fetchConnections",{userAgent:navigator.userAgent.toLowerCase(), referrer:document.referrer});
    //const expiresIn = +tokenExpiration - new Date().getTime();
    //try 로그인 할때만다 로그인유지 시간 늘림
    let expiresIn = +logintime;

    localStorage.setItem("expiresIn", expiresIn);

    if (expiresIn < 0) {
      return;
    }

    timer = setTimeout(function() {
      context.dispatch("autoLogout");
    }, expiresIn);
    //console.log(userId);
    //console.log("암호화 전 token" +  tokenData.user.access_token);

    if (token && userId) {
      //console.log("token과 currentUser가 있으면" + userId);
        http().get("/auth/profile").then((response)=>{
            context.commit("setUser", {
                token: auth.getAccessToken(),
                currentUser: response.data
            });
            //console.log('response'+response.data.nic)
        })
    }
  },
  logout(context) {
    localStorage.removeItem("lv_token");
    localStorage.removeItem("userId");
    localStorage.removeItem("tokenExpiration");
    localStorage.removeItem("vuex");
    localStorage.removeItem("expiresIn");
    clearTimeout(timer);

    context.commit("setUser", {
      token: null,
      currentUser: null,
    });

  },
  autoLogout(context) {
    context.dispatch("logout");
    context.commit("setAutoLogout");
  },

  //회원가입
  signup(context, payload) {
    return http()
    .post("/auth/signup", payload)
    .then((response) => {
      if (response.status === 200) {
        console.log(response);

      }
      return response.data;
    });
  },
   async getProfile(context) {
    try {
     const response = await context.getters.http.get("/auth/profile")
     console.log('getProfile'+JSON.stringify(response.data));
    }catch(error){
        console.log(error.response);
      }
    },
    leave_service(_,data) {        
      return http()
      .post("/auth/leave_service",data)
      .then((response) => {            
          //console.log("넘겨받은 데이터 확인",response.data);
          return response.data;
      },function(error){
          console.log(error.response.data);
          return error.response.data;
      });        
    },   
};
